/* eslint-disable react/jsx-props-no-spreading */
import { Alert, AlertTitle } from '@mui/material';
import React from 'react';
import TripReviewGiftForm, { FormProps } from './form';

type TripReviewGiftFormViewProps = {
  isLoading: boolean
  isError: boolean
  formProps: FormProps
};

const TripReviewGiftFormView = ({
  isLoading,
  isError,
  formProps,
}: TripReviewGiftFormViewProps) => {
  if (isLoading) {
    return null;
  }

  if (isError) {
    return (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        There was an error loading the form. Please try again later.
      </Alert>
    );
  }

  return (
    <TripReviewGiftForm
      {...formProps}
    />
  );
};

export default TripReviewGiftFormView;
